export default {
  mod_pwd_wrond: 'Wrong password',
  mod_pwd_required: 'Current password required',
  mod_tfa_required: '2FA required',
  mod_confirm_seed: 'Account blocked. You cannot make any operations. Please, enter the Seed-phrase to unblock your account.',
  mod_confirm_seed_login: 'Account blocked. Please, enter the Seed-phrase to unblock your account.',
  mod_save_seed: 'This is your seed phrase.',
  mod_save_seed_subtitle: 'It is needed to restore the access if you’ve lost or forgotten the password. Make sure your seed phrase stays securely stored.',
  mod_why_save_seed: `For security reasons, please put this seed in some secret place.
                      You will need it to recover access in case if your account will be lost.`,
  mod_validate_seed_how: 'Please also copy the seed phrase into the space below:',
  mod_confirm_title: 'Are you sure?',
  mod_withdrawal_confirm_title: 'Are you sure you want to cancel the withdrawal transaction?',
  mod_withdrawal_confirm_message: 'The funds will be returned to your balance.',
  mod_confirm_message: 'Please confirm this action before continuing',
  mod_confirm_confirm_text: 'Confirm',
  mod_confirm_cancel_text: 'Cancel',
  mod_email_not_verified_title: 'Email not verified',
  mod_email_not_verified_message: `It seems your email is not verified yet. Please check your spam folder or request new email by pressing "Confirm"`,
  mod_accountBlocked_title: 'Account blocked',
  mod_accountBlocked_message: `You can't make transactions anymore`,
  mod_under_construct_title: 'This page is temporarily under construction',
  mod_under_construct_text: 'If you have any questions, then write to support - we will help you solve your problems',
  mod_empty_fund_logo: 'Add a logo or video to preview your campaign',
  mod_empty_fund_description: 'Add a description of your campaign',
  mod_empty_token_logo: 'Add your asset logo'
}



// WEBPACK FOOTER //
// ./src/js/i18n/views/modals.js